import React from 'react';
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSection';
import HeroSection2 from '../HeroSection2';

function Home() {
  return (
    <>

      <HeroSection />          <HeroSection2 />


      <Cards />
    </>
  );
}

export default Home;